export const CHAT_LOCK_VIEWPORT_CLASS = "chat-lock-viewport";

let overlayBodyScrollLockCount = 0;

export function isChatViewportLocked(): boolean {
  return typeof document !== "undefined" && document.documentElement.classList.contains(CHAT_LOCK_VIEWPORT_CLASS);
}

/** Clear the overlay inline lock so `html.chat-lock-viewport` CSS can keep body overflow hidden. */
export function restoreDocumentBodyOverflow(): void {
  if (typeof document === "undefined") {
    return;
  }

  document.body.style.overflow = isChatViewportLocked() ? "" : "visible";
}

/** Shared Dialog + DrawerModal lock so closing one overlay does not unlock the other. */
export function lockDocumentBodyScroll(): void {
  if (typeof document === "undefined") {
    return;
  }

  overlayBodyScrollLockCount += 1;
  if (overlayBodyScrollLockCount === 1) {
    document.body.style.overflow = "hidden";
  }
}

export function unlockDocumentBodyScroll(): void {
  if (typeof document === "undefined") {
    return;
  }

  overlayBodyScrollLockCount = Math.max(0, overlayBodyScrollLockCount - 1);
  if (overlayBodyScrollLockCount === 0) {
    restoreDocumentBodyOverflow();
  }
}

export function resetDocumentBodyScrollLockForTests(): void {
  overlayBodyScrollLockCount = 0;
  if (typeof document !== "undefined") {
    restoreDocumentBodyOverflow();
  }
}
